/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Story_Formulas_TextInputs */

const en_gc_story_formulas_text = /** @type {(inputs: Gc_Story_Formulas_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Build confidence with a calculation you can verify yourself. Enter a few amounts, total them with SUM, then use IF to label a value above a chosen threshold. Change one source cell and watch the result update. The upstream project documents more than 500 worksheet functions, including dynamic array features, LET and LAMBDA. That breadth gives you room to explore, but it does not replace checking your own results. Workbooks using specialist Excel functions, external data or macros need separate evaluation. Our formula tutorial starts with small, reproducible examples.`)
};

const zh_gc_story_formulas_text = /** @type {(inputs: Gc_Story_Formulas_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`先用能自己核对的计算建立信心：输入几个金额，用 SUM 求和，再用 IF 标记超过阈值的数值。修改来源单元格，观察结果更新。上游项目记录了超过 500 个工作表函数，包括动态数组、LET 和 LAMBDA。功能丰富仍不能代替结果核对；涉及专业函数、外部数据或宏的工作簿需要单独评估。公式教程从小而可复现的示例开始。`)
};

/**
* | output |
* | --- |
* | "Build confidence with a calculation you can verify yourself. Enter a few amounts, total them with SUM, then use IF to label a value above a chosen threshold...." |
*
* @param {Gc_Story_Formulas_TextInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_story_formulas_text = /** @type {((inputs?: Gc_Story_Formulas_TextInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Story_Formulas_TextInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_story_formulas_text(inputs)
	return zh_gc_story_formulas_text(inputs)
});
export { gc_story_formulas_text as "gc.story.formulas.text" }